export const MERCHANT_MONITORING_PROCESS_NAME = 'merchantMonitoring' as const;
